import { atom } from "recoil"

export const trashboxContactsConcatRequestIdState = atom({
  key: "atoms/contact/trashboxContactsConcatRequestIdState",
  default: 0,
})
